import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import httpService from "../../../services/http.service";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import { Link, Route, Switch } from "react-router-dom";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import UserOpinions from "./opinions";
import UserProfile from "./profile";
import UserComments from "./comments";
import UserAgoras from "./agoras";
import UserFriends from "./friends";
import UserFollowers from "./followers";
import { Form, FormGroup } from "reactstrap";
import AppAlert from "../../Shared/AppAlert";
import useAlert from "../../../hooks/useAlert";
import { useFormik } from "formik";
import AppDatePicker from "../../Shared/AppDatePicker";
import * as Yup from 'yup';
import { extractResponseValidationErrors, VERIFIED, GOLD, getUserFullName, USER_TYPE_USER, formatCash } from "../../../utils/index";
import UserSubscriptions from "./subscriptions";
import UserReferral from "./referral";
import AppSelect from "../../Shared/AppSelect";
import AppInput from '../../Shared/AppInput';
import KpiCard from "../../Shared/KpiCard";
import { Dropdown } from 'react-bootstrap';

const classnames = require('classnames');

const UserDetails = ({ history, location, match, ...props }) => {
    const { t } = useTranslation();

    const initialValues = {
        user_unmute_at: ''
    }

    const userBlockInitialValues = {
        user_unblock_at: ''
    }

    const subscriptionInitialValues = {
        subscr_type: '',
        subscr_period: '',
        subscr_user_id: '',
    };

    const coinInitialValues = {
        coin: 0,
    };

    const [user, setuser] = useState(null);
    const [fetching, setFetching] = useState(true);
    const [modal, setModal] = useState({
        mute: false,
        block: false,
        subscription: false,
        coin: false,
        specialContent: false
    });
    const [alert, setAlert, onClose] = useAlert();
    const [submitting, setSubmission] = useState(false);
    const [ddls, setDdls] = useState({
        subscriptionTypes: [],
        subscriptionPeriods: [],
    });

    const toggleBlock = async () => {

        if (!user.user_blocked) {
            setModal(state => ({
                ...state,
                block: true
            }));
        } else {
            if (!window.confirm(i18n.t("Confirmer ?"))) return;

            const { data: response } = await httpService.put(`/users/${user.user_username}/toggleBlock`);

            setuser(state => ({
                ...state,
                user_blocked: !user.user_blocked
            }));
        }

    }

    const toggleMute = async () => {

        if (!user.user_muted) {
            setModal(state => ({
                ...state,
                mute: true
            }));
        } else {
            if (!window.confirm(i18n.t("Confirmer ?"))) return;

            const { data: response } = await httpService.put(`/users/${user.user_username}/toggleMute`);

            setuser(state => ({
                ...state,
                user_muted: !user.user_muted,
                user_unmute_at: null,
                user_delete_at: null
            }));
        }
    }

    const onDelete = async () => {
        if (!window.confirm(i18n.t("Confirmer ?"))) return;

        const { data: response } = await httpService.delete(`/users/${user.user_username}`);

        history.replace(`/users?user_type=${USER_TYPE_USER}`)
    }

    const onRestoreAuthorisation = async () => {
        if (!window.confirm(i18n.t("Confirmer ?"))) return;

        const { data: response } = await httpService.post(`/users/${user.user_username}/restore_authorization`);

        setuser(state => ({
            ...state,
            authorization: response?.data?.authorization
        }))
    }

    const togglePublicPostAllowed = async () => {
        if (!window.confirm(i18n.t("Confirmer ?"))) return;

        const { data: response } = await httpService.post(`/users/${user.user_username}/toggle_public_post_allowed`);

        setuser(state => ({
            ...state,
            user_public_post_allowed: response?.data?.user_public_post_allowed
        }))
    }

    const toggleSpecialContentCreation = async () => {
        if (!window.confirm(i18n.t("Confirmer ?"))) return;

        setSubmission(true);
        setAlert(null);

        try {
            const { data: response } = await httpService.post(`/users/${user.user_username}/toggle_special_content_creation`);
            
            setuser(state => ({
                ...state,
                user_can_create_special_content: response?.data?.user_can_create_special_content
            }));
            
            setModal(state => ({
                ...state,
                specialContent: false
            }));
            
        } catch ({ response }) {
            const { data, status } = response;

            if (response && status === 422) {
                setAlert({
                    type: 'danger',
                    message: extractResponseValidationErrors(data)[0]
                })
            }
            else if (response && status === 500) {
                setAlert({
                    type: 'danger',
                    message: i18n.t("Erreur de traitement, veuillez contacter les administrateurs")
                })
            }
        }
        finally {
            setSubmission(false);
        }
    }

    const fetchUser = async (id, cb = () => null) => {
        const { data: response } = await httpService.get(`users/${match.params.id}`);
        const user = {
            ...response.data,
            soutiens_count: response.soutiens_count
        };
        // console.log("=============", response)
        setuser(user);
        cb();
        return user;
    };

    const fetchSubscriptionPeriods = async (cb = () => null) => {
        const { data: response } = await httpService.get(`/subscription_periods`);
        cb(response);
        return response;
    }

    const fetchSubscriptionTypes = async (cb = () => null) => {
        const { data: response } = await httpService.get(`/subscription_types`);
        cb(response);
        return response;
    }

    const onSubmit = async (values) => {

        setSubmission(true);
        setAlert(null);

        try {
            const { data: response } = await httpService.put(`/users/${user.user_username}/toggleMute`, values);
            setuser(state => ({
                ...state,
                user_muted: !user.user_muted,
                user_unmute_at: response.data.user_unmute_at
            }));
            onCancel();
        } catch ({ response }) {

            const { data, status } = response;

            if (response && status === 422) {
                setAlert({
                    type: 'danger',
                    message: extractResponseValidationErrors(data)[0]
                })
            }
            else if (response && status === 500) {
                setAlert({
                    type: 'danger',
                    message: i18n.t("Erreur de traitement, veuillez contacter les administrateurs")
                })
            }

        }
        finally {
            setSubmission(false);
        }

    }

    const onUserBlockFormSubmit = async (values) => {

        setSubmission(true);
        setAlert(null);

        try {
            const { data: response } = await httpService.put(`/users/${user.user_username}/toggleBlock`, values);
            setuser(state => ({
                ...state,
                user_blocked: !user.user_blocked,
                user_unblock_at: response.data.user_unblock_at
            }));
            onCancel();
        } catch ({ response }) {

            const { data, status } = response;

            if (response && status === 422) {
                setAlert({
                    type: 'danger',
                    message: extractResponseValidationErrors(data)[0]
                })
            }
            else if (response && status === 500) {
                setAlert({
                    type: 'danger',
                    message: i18n.t("Erreur de traitement, veuillez contacter les administrateurs")
                })
            }

        }
        finally {
            setSubmission(false);
        }

    }

    const onSubmitSubscriptionForm = async (values) => {
        setSubmission(true);
        setAlert(null);

        try {
            const { data: response } = await httpService.post(`/subscriptions/offer_to_user`, {
                ...values,
                subscr_user_id: user?.user_id,
            });
            setuser(state => ({
                ...state,
                user_verified: values.subscr_type === VERIFIED ? true : state?.user_verified,
                user_gold: values.user_gold === GOLD ? true : state?.user_gold,
                subscriptions_count: Number.parseInt(state?.subscriptions_count) + 1
            }));
            onCancel();
        } catch ({ response }) {

            const { data, status } = response;

            if (response && status === 422) {
                setAlert({
                    type: 'danger',
                    message: extractResponseValidationErrors(data)[0]
                })
            }
            else if (response && status === 500) {
                setAlert({
                    type: 'danger',
                    message: i18n.t("Erreur de traitement, veuillez contacter les administrateurs")
                })
            }

        }
        finally {
            setSubmission(false);
        }
    }


    const onCoinFormSubmit = async (values) => {

        setSubmission(true);
        setAlert(null);

        try {
            const { data: response } = await httpService.post(`/users/${user.user_username}/offer-coins`, values);
            console.log("======", response)
            fetchUser()
            onCancel();
        } catch ({ response }) {

            const { data, status } = response;

            if (response && status === 422) {
                setAlert({
                    type: 'danger',
                    message: extractResponseValidationErrors(data)[0]
                })
            }
            else if (response && status === 500) {
                console.error(response);
                
                setAlert({
                    type: 'danger',
                    message: i18n.t("Erreur de traitement, veuillez contacter les administrateurs")
                })
            }

        }
        finally {
            setSubmission(false);
        }

    }

    const onCancel = () => {
        formik.resetForm(initialValues);
        userBlockFormik.resetForm(userBlockInitialValues);
        subscriptionFormik.resetForm(subscriptionInitialValues);
        setAlert(null);
        setModal(state => ({
            ...state,
            mute: false,
            subscription: false,
            block: false,
            coin: false,
            specialContent: false
        }));
    }

    useEffect(() => {

        try {
            fetchUser(match.params.id, async () => {

                const subscriptionTypes = await fetchSubscriptionTypes()
                const subscriptionPeriods = await fetchSubscriptionPeriods()

                setDdls(state => ({
                    ...state,
                    subscriptionTypes,
                    subscriptionPeriods
                }))

                setFetching(false);
            });

        } catch (e) {
            throw e;
        }

    }, []);

    const formik = useFormik({
        initialValues,
        validationSchema: Yup.object().shape({
            user_unmute_at: Yup.string().ensure().required(t("Champ obligatoire"))
        }),
        onSubmit
    });

    const userBlockFormik = useFormik({
        initialValues: userBlockInitialValues,
        validationSchema: Yup.object().shape({
            user_unblock_at: Yup.string().ensure().nullable()
        }),
        onSubmit: onUserBlockFormSubmit
    });

    const subscriptionFormik = useFormik({
        initialValues: subscriptionInitialValues,
        validationSchema: Yup.object().shape({
            subscr_type: Yup.string().ensure().required(t("Champ obligatoire")),
            subscr_period: Yup.string().ensure().required(t("Champ obligatoire")),
            subscr_user_id: Yup.string().ensure().nullable(),
        }),
        onSubmit: onSubmitSubscriptionForm
    });


    const coinFormik = useFormik({
        initialValues: coinInitialValues,
        validationSchema: Yup.object().shape({
            coin: Yup.string().ensure().required(t("Champ obligatoire"))
        }),
        onSubmit: onCoinFormSubmit
    });


    if (fetching) {
        return <FecthingSpinner />
    }

    const social = !!process.env.REACT_APP_SOCIAL_HUB;
    const base = `/users/${match.params.id}`;
    const tabs = [
        {to: base, icon: 'fa-user', label: t("Profil")},
        {to: `${base}/opinions`, icon: 'fa-pencil', label: social ? t("Posts") : t("Opinions"), count: user.opinions_count || 0},
        {to: `${base}/agoras`, icon: 'fa-globe', label: social ? t("Groupes") : t("Agoras"), count: user.agoras_count || 0},
        {to: `${base}/comments`, icon: 'fa-comments', label: t("Commentaires"), count: user.comments_count || 0},
        {to: `${base}/friends`, icon: 'fa-group', label: social ? t("Contacts") : t("Potes"), count: (user.friends_invited_count || 0) + (user.friends_accepted_count || 0)},
        {to: `${base}/followers`, icon: 'fa-star', label: social ? t("Abonnés") : t("Fans"), count: user.followers_count || 0},
        {to: `${base}/subscriptions`, icon: 'fa-diamond', label: t("Souscriptions"), count: user.subscriptions_count || 0},
    ].map(tab => ({...tab, active: decodeURIComponent(location.pathname) === decodeURIComponent(tab.to)}));

    return (
        <div className="container-fluid">
            <AppBreadcrumb title={social ? t("Utilisateur") : t("Utilisateur")}>
                <div className="col-md-6 col-sm-12 text-right hidden-xs">
                    <Link to={`/users?user_type=${user.user_type}`} className="btn btn-sm btn-light">
                        <i className="fa fa-arrow-left"></i>{' '}{t("Retour à la liste")}
                    </Link>
                </div>
            </AppBreadcrumb>

            {/* En-tête du profil : identité, états, actions */}
            <div className="card profile-hero">
                <div className="profile-hero__band" />
                <div className="profile-hero__content">
                    <img className="profile-hero__avatar" src={user?.profile?.prof_picture || MyOpinionLogo} alt="" />
                    <div className="profile-hero__identity">
                        <h4 className="profile-hero__name">
                            {getUserFullName(user)}
                            {user.user_verified ? <i title={t("Certifié")} className="fa fa-check-circle text-primary" /> : null}
                            {user.user_gold ? <i title={t("Premium / Gold")} className="fa fa-star text-warning" /> : null}
                        </h4>
                        <div className="profile-hero__meta">
                            <span className="profile-hero__username">@{user.user_username}</span>
                            {user.user_email && <span><i className="fa fa-envelope-o"></i> {user.user_email}</span>}
                            {user?.ip_country?.ip_country_name && <span><i className="fa fa-map-marker"></i> {user.ip_country.ip_country_name}</span>}
                            {user.user_created_at && <span><i className="fa fa-calendar"></i> {t("Inscrit le {{d}}", {d: user.user_created_at})}</span>}
                        </div>
                        <div className="profile-hero__badges">
                            {user.user_blocked ? (
                                <span className="badge badge-danger ml-0">{user.user_unblock_at ? t("Restreint jusqu'au {{d}}", {d: user.user_unblock_at}) : t("Bloqué")}</span>
                            ) : null}
                            {user.user_muted ? (
                                <span className="badge badge-warning ml-0"><i className="fa fa-volume-off"></i> {user.user_unmute_at ? t("Muet jusqu'au {{d}}", {d: user.user_unmute_at}) : t("Muet")}</span>
                            ) : null}
                            {user.user_active === false || user.user_active === 0 ? <span className="badge badge-secondary ml-0">{t("Inactif")}</span> : null}
                            {user.user_can_create_special_content ? <span className="badge badge-info ml-0">{t("Contenu spécial autorisé")}</span> : null}
                        </div>
                    </div>

                    {/* Actions : modération, puis offres */}
                    <div className="profile-hero__actions">
                        {social && (user.user_blocked ? (
                            <button className="btn btn-sm btn-outline-success" onClick={toggleBlock}><i className="fa fa-check-circle"></i>{' '}{t("Lever la restriction")}</button>
                        ) : (
                            <button className="btn btn-sm btn-outline-danger" onClick={toggleBlock}><i className="fa fa-minus-circle"></i>{' '}{t("Restreindre")}</button>
                        ))}
                        {user.user_muted ? (
                            <button className="btn btn-sm btn-outline-success" onClick={toggleMute}><i className="fa fa-volume-up"></i>{' '}{t("Rétablir la parole")}</button>
                        ) : (
                            <button className="btn btn-sm btn-outline-warning" onClick={toggleMute}><i className="fa fa-volume-off"></i>{' '}{t("Rendre muet")}</button>
                        )}
                        <button className={`btn btn-sm ${user.user_can_create_special_content ? 'btn-outline-secondary' : 'btn-outline-info'}`}
                                onClick={() => setModal(state => ({ ...state, specialContent: true }))}>
                            <i className={`fa ${user.user_can_create_special_content ? 'fa-eye-slash' : 'fa-check-circle'}`}></i>{' '}
                            {user.user_can_create_special_content ? t("Bloquer le contenu spécial") : t("Autoriser le contenu spécial")}
                        </button>
                        <Dropdown alignRight>
                            <Dropdown.Toggle size="sm" variant="primary" id="user-offer-menu">
                                <i className="fa fa-gift"></i>{' '}{t("Offrir")}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as="button" type="button" onClick={() => setModal(state => ({ ...state, subscription: true }))}>
                                    <i className="fa fa-diamond mr-2"></i>{t("Un abonnement")}
                                </Dropdown.Item>
                                <Dropdown.Item as="button" type="button" onClick={() => setModal(state => ({ ...state, coin: true }))}>
                                    <i className="fa fa-database mr-2"></i>{t("Des coins")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </div>

            {/* Statistiques du compte */}
            <div className="row clearfix equal-height-row">
                <div className="col-lg-3 col-md-6">
                    <KpiCard icon="fa-pencil" tone="blue" label={social ? t("Posts") : t("Opinions")} value={formatCash(user.opinions_count || 0)}
                             hint={t("{{c}} commentaire(s) · {{a}} agora(s)", {c: formatCash(user.comments_count || 0), a: formatCash(user.agoras_count || 0)})} />
                </div>
                <div className="col-lg-3 col-md-6">
                    <KpiCard icon="fa-thumbs-o-up" tone="green" label={t("Réactions reçues")} value={formatCash(user.soutiens_count || 0)}
                             hint={t("Soutiens reçus sur ses opinions")} />
                </div>
                <div className="col-lg-3 col-md-6">
                    <KpiCard icon="fa-database" tone="orange" label={t("Solde")} value={`${formatCash(user.user_wallet_balance || 0)} ${t("pièces")}`}
                             hint={t("{{l}} likes · {{v}} vues", {l: formatCash(user.user_like_balance || 0), v: formatCash(user.user_view_balance || 0)})} />
                </div>
                <div className="col-lg-3 col-md-6">
                    <KpiCard icon="fa-users" tone="purple" label={social ? t("Abonnés") : t("Fans")} value={formatCash(user.followers_count || 0)}
                             hint={t("{{p}} {{pl}} · suit {{s}} compte(s)", {
                                 p: formatCash((user.friends_invited_count || 0) + (user.friends_accepted_count || 0)),
                                 pl: social ? t("contacts") : t("potes"),
                                 s: formatCash(user.followed_count || 0),
                             })} />
                </div>
            </div>

            <UserReferral username={user.user_username} />

            {/* Onglets */}
            <ul className="nav stats-tabs profile-tabs" role="tablist">
                {tabs.map(tab => (
                    <li className="nav-item" key={tab.to}>
                        <Link to={tab.to} role="tab" aria-selected={tab.active} className={classnames('nav-link', {active: tab.active})}>
                            <i className={`fa ${tab.icon}`}></i>{' '}{tab.label}
                            {tab.count !== undefined && <span className="badge badge-pill badge-light ml-2">{formatCash(tab.count)}</span>}
                        </Link>
                    </li>
                ))}
            </ul>

            <div className="row">
                <div className="col-12">
                    <Switch>
                        <Route
                            path={`/users/:id`}
                            exact
                            render={(props) => <UserProfile user={user} onDelete={onDelete} togglePublicPostAllowed={togglePublicPostAllowed} onRestoreAuthorisation={onRestoreAuthorisation} {...props} />}
                        />
                        <Route
                            path={`/users/:id/opinions`}
                            render={(props) => <UserOpinions user={user} {...props} />}
                        />
                        <Route
                            path={`/users/:id/comments`}
                            render={(props) => <UserComments user={user} {...props} />}
                        />
                        <Route
                            path={`/users/:id/agoras`}
                            render={(props) => <UserAgoras user={user} {...props} />}
                        />
                        <Route
                            path={`/users/:id/friends`}
                            render={(props) => <UserFriends user={user} {...props} />}
                        />
                        <Route
                            path={`/users/:id/followers`}
                            render={(props) => <UserFollowers user={user} {...props} />}
                        />
                        <Route
                            path={`/users/:id/subscriptions`}
                            render={(props) => <UserSubscriptions user={user} {...props} />}
                        />
                    </Switch>
                </div>
            </div>

            <div className={`modal fade ${modal.block ? 'd-block show' : ''}`} id="exampleModal" onClick={() => null}>
                <div className="modal-dialog modal-md" role="document">
                    <Form onSubmit={userBlockFormik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">{t("Restriction de l'utilisateur")}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label={t("Close")} onClick={onCancel}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                                <AppDatePicker
                                    label={t("Restreindre jusqu'au ?")}
                                    className="form-control"
                                    error={userBlockFormik.errors.user_unblock_at}
                                    touched={userBlockFormik.touched.user_unblock_at}
                                    value={userBlockFormik.values.user_unblock_at}
                                    onChange={(date) => userBlockFormik.setFieldValue('user_unblock_at', date)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                    <span className="fa fa-times"></span>{' '}Annuler
                                </button>
                                <button type="submit" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting}>
                                    <span className="fa fa-save"></span>{' '}{submitting ? 'Encour...' : 'Enregistrer'}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>

            <div className={`modal fade ${modal.mute ? 'd-block show' : ''}`} id="exampleModal" onClick={() => null}>
                <div className="modal-dialog modal-md" role="document">
                    <Form onSubmit={formik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">{t("Mute utilisateur")}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label={t("Close")} onClick={onCancel}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                                <AppDatePicker
                                    label={t("Invisible jusqu'au ?")}
                                    className="form-control"
                                    error={formik.errors.user_unmute_at}
                                    touched={formik.touched.user_unmute_at}
                                    value={formik.values.user_unmute_at}
                                    onChange={(date) => formik.setFieldValue('user_unmute_at', date)}
                                    required
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                    <span className="fa fa-times"></span>{' '}Annuler
                                </button>
                                <button type="submit" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting}>
                                    <span className="fa fa-save"></span>{' '}{submitting ? 'Encour...' : 'Enregistrer'}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>

            <div className={`modal fade ${modal.subscription ? 'd-block show' : ''}`} id="exampleModal" onClick={() => null}>
                <div className="modal-dialog modal-md" role="document">
                    <Form onSubmit={subscriptionFormik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">{t("Abonnement gratuit")}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label={t("Close")} onClick={onCancel}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                                <AppSelect
                                    name="subscr_type"
                                    label={t("Type d'abonnement")}
                                    placeholder={t("Selectionnez le type d'abonnement")}
                                    value={subscriptionFormik.values.subscr_type}
                                    onChange={subscriptionFormik.handleChange}
                                    onBlur={subscriptionFormik.handleBlur}
                                    error={subscriptionFormik.errors.subscr_type}
                                    touched={subscriptionFormik.touched.subscr_type}
                                    required
                                >
                                    {ddls.subscriptionTypes.map(obj => (
                                        <option key={obj?.value} value={obj?.value}>{obj?.label}</option>
                                    ))}
                                </AppSelect>
                                <AppSelect
                                    name="subscr_period"
                                    label={t("Durée de l'abonnement")}
                                    placeholder={t("Selectionnez la durée de l'abonnement")}
                                    value={subscriptionFormik.values.subscr_period}
                                    onChange={subscriptionFormik.handleChange}
                                    onBlur={subscriptionFormik.handleBlur}
                                    error={subscriptionFormik.errors.subscr_period}
                                    touched={subscriptionFormik.touched.subscr_period}
                                    required
                                >
                                    {ddls.subscriptionPeriods.map(obj => (
                                        <option key={obj?.value} value={obj?.value}>{obj?.label}</option>
                                    ))}
                                </AppSelect>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                    <span className="fa fa-times"></span>{' '}Annuler
                                </button>
                                <button type="submit" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting}>
                                    <span className="fa fa-save"></span>{' '}{submitting ? 'Encour...' : 'Enregistrer'}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>

            <div className={`modal fade ${modal.coin ? 'd-block show' : ''}`} id="exampleModal" onClick={() => null}>
                <div className="modal-dialog modal-md" role="document">
                    <Form onSubmit={coinFormik.handleSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">{t("Offrir des coins")}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label={t("Close")} onClick={onCancel}>
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                                <AppInput
                                    name="coin"
                                    label={t("Nombre de coin")}
                                    placeholder={t("Définissez le nombre de coin")}
                                    value={coinFormik.values.coin}
                                    onChange={coinFormik.handleChange}
                                    onBlur={coinFormik.handleBlur}
                                    error={coinFormik.errors.coin}
                                    touched={coinFormik.touched.coin}
                                    type="number"
                                    required
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                    <span className="fa fa-times"></span>{' '}Annuler
                                </button>
                                <button type="submit" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting}>
                                    <span className="fa fa-save"></span>{' '}{submitting ? 'Encour...' : 'Enregistrer'}
                                </button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>

            <div className={`modal fade ${modal.specialContent ? 'd-block show' : ''}`} id="exampleModal" onClick={() => null}>
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {user?.user_can_create_special_content ? 'Bloquer' : 'Autoriser'} la création de contenu spécial
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label={t("Close")} onClick={onCancel}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {alert && <AppAlert onClose={onClose} type={alert.type}>{alert.message}</AppAlert>}
                            <p>
                                {user?.user_can_create_special_content 
                                    ? i18n.t("Voulez-vous bloquer cet utilisateur de créer du contenu spécial ?") 
                                    : i18n.t("Voulez-vous autoriser cet utilisateur à créer du contenu spécial ?")}
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className={`btn btn-round btn-danger font-weight-bold`} disabled={submitting} data-dismiss="modal" onClick={onCancel}>
                                <span className="fa fa-times"></span>{' '}Annuler
                            </button>
                            <button type="button" className={`btn btn-round btn-success font-weight-bold`} disabled={submitting} onClick={toggleSpecialContentCreation}>
                                <span className="fa fa-check"></span>{' '}{submitting ? 'Encour...' : 'Confirmer'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserDetails;